import React from "react";
import { Nft1, Nft2, Nft3 } from "../../constant/Index";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import { useAboutContentQuery } from "../../store/services/AboutService";
import { useImageContentQuery } from "../../store/services/ImageService";

const About = () => {
	const { data, isLoading } = useAboutContentQuery();
	let response = data?.response?.data[0];
	const { data: nftImage, isLoading: nftLoading } = useImageContentQuery();
	let NftImages = nftImage?.response?.data;
	return (
		<>
			{/* <!-- About Sec Start Here --> */}
			<section className="about_sec text-white">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-6">
							<div className="left-box">
								<div className="glowing glowing-one">
									<span></span>
									<span></span>
								</div>
								<div className="glowing glowing-two">
									<span></span>
									<span></span>
								</div>
								<div className="glowing glowing-three">
									<span></span>
									<span></span>
								</div>
								<Swiper
									className="nft-slider swiper mySwiper"
									effect={"cards"}
									grabCursor={true}
									modules={[EffectCards]}
								>
									<div className="swiper-wrapper">
										{NftImages?.map((data, index) => {
											return (
												<SwiperSlide key={data?.id} className="swiper-slide">
													<img
														src={data?.image_path}
														alt=""
														className="img-fluid"
													/>
												</SwiperSlide>
											);
										})}
									</div>
								</Swiper>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="content-wrapper">
								<div className="title">
									<h5 className="title wow animate__animated animate__fadeInLeft">
										<span>ABOUT US</span>
									</h5>
									<h2 className="wow animate__animated animate__fadeInLeft animate__delay-1s">
										{response?.title}
									</h2>
								</div>
								<p dangerouslySetInnerHTML={{ __html: response?.heading }}></p>
								<div
									className="row"
									dangerouslySetInnerHTML={{ __html: response?.description }}
								></div>
								{/* <div className="row">
									<div className="col-md-6">
										<div className="boxes-content wow animate__animated animate__fadeInUp animate__delay-3s">
											<h3 className="title-text">General Community</h3>
											<p>
												With our community, join hot discussions, thought
												leaders, and crypto enthusiasts to plan out your growth
												and success in the NFT world.
											</p>
										</div>
									</div>
									<div className="col-md-6">
										<div className="boxes-content wow animate__animated animate__fadeInUp animate__delay-3s">
											<h3 className="title-text">Exclusive Community</h3>
											<p>
												Be a part of our high-class, elite NFT enthusiasts with
												exclusive access to premium deals, higher loan
												offerings, limited utilities, and more.
											</p>
										</div>
									</div>
								</div> */}
								<div className="button-group wow animate__animated animate__fadeInUp animate__delay-4s">
									<a href="/about" className="buy-btn blue">
										<span className="txt">READ MORE</span>
										<span className="svg-icon">
											<svg width="28" height="28" viewBox="0 0 28 28">
												<defs>
													<filter
														id="Ellipse_15"
														x="0"
														y="0"
														width="28"
														height="28"
														filterUnits="userSpaceOnUse"
													>
														<feOffset dy="2" input="SourceAlpha" />
														<feGaussianBlur stdDeviation="1" result="blur" />
														<feFlood floodOpacity="0.302" />
														<feComposite operator="in" in2="blur" />
														<feComposite in="SourceGraphic" />
													</filter>
												</defs>
												<g
													id="Group_27"
													data-name="Group 27"
													transform="translate(-340 -668)"
												>
													<g
														transform="matrix(1, 0, 0, 1, 340, 668)"
														filter="url(#Ellipse_15)"
													>
														<circle
															id="Ellipse_15-2"
															data-name="Ellipse 15"
															cx="11"
															cy="11"
															r="11"
															transform="translate(3 1)"
															fill="#f9f928"
														/>
													</g>
													<path
														id="Path_16"
														data-name="Path 16"
														d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
														transform="translate(-233.954 281.611)"
														fill="#d13900"
													/>
												</g>
											</svg>
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- About Sec End Here --> */}
		</>
	);
};

export default About;
